import { StoredFileModel } from './StoredFile';
import { AppUtils } from '../../utils/index';

export class UploadContainerModel {
	private files: Array<StoredFileModel>;
	private containerId: string;


	set Files(value: Array<StoredFileModel>) {
		this.files = value;
	}

	get Files(): Array<StoredFileModel> {
		return this.files;
	}

	set ContainerId(value: string) {
		this.containerId = value;
	}

	get ContainerId(): string {
		return this.containerId;
	}

	/**
	 * Creates a new model object and copies the values from the provided data object (or other application model) to the created model.
	 */
	public static createFromObject(dataObject: { [key: string]: any }): UploadContainerModel {
		let arr: Array<StoredFileModel>;
		return AppUtils.Helper.createFromMap(dataObject, UploadContainerModel, (key: string, value: any) => {
			if (key.toLowerCase() === 'files') {
				arr = new Array<StoredFileModel>();
				value.forEach((datei: StoredFileModel) => {
					arr.push(StoredFileModel.createFromObject(datei));
				});
				return arr;
			} else {
				return value;
			}
		});
	}
}